import { motion, useReducedMotion } from "framer-motion";
import { EASE, Eyebrow, FadeUp } from "./Reveal";

export const PageShell = ({ eyebrow, title, intro, image, imageAlt = "", children, testId }) => {
  const reduced = useReducedMotion();
  return (
    <div data-testid={testId}>
      <section className="relative flex min-h-[66vh] items-end overflow-hidden pt-36">
        <motion.img
          src={image}
          alt={imageAlt}
          fetchpriority="high"
          initial={reduced ? { opacity: 0 } : { scale: 1.08, opacity: 0.5 }}
          animate={reduced ? { opacity: 1 } : { scale: 1, opacity: 1 }}
          transition={{ duration: 1.4, ease: EASE }}
          className="img-lux-grade absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-[#050505]/30 to-[#050505]" />
        <div className="relative z-10 mx-auto w-full max-w-[1280px] px-6 pb-20 lg:px-12">
          <FadeUp y={20}>
            <Eyebrow>{eyebrow}</Eyebrow>
          </FadeUp>
          <span className="mt-6 block overflow-hidden pb-[0.15em]">
            <motion.h1
              initial={reduced ? { opacity: 0 } : { y: "112%" }}
              animate={reduced ? { opacity: 1 } : { y: 0 }}
              transition={{ duration: 0.95, delay: 0.12, ease: EASE }}
              className="block max-w-3xl font-serif text-4xl font-medium leading-[1.08] tracking-[-0.01em] text-ivory sm:text-5xl lg:text-[56px]"
            >
              {title}
            </motion.h1>
          </span>
          {intro && (
            <FadeUp delay={0.32}>
              <p className="mt-6 max-w-xl text-sm font-light leading-relaxed text-ivory-muted sm:text-base">
                {intro}
              </p>
            </FadeUp>
          )}
        </div>
      </section>
      {children}
    </div>
  );
};
